import {
  GridView as GridViewIcon,
  Lock as LockIcon,
  ViewWeek as ViewWeekIcon,
} from '@mui/icons-material';
import {
  CardContainer,
  CardInfoTitle,
  CardText,
  ChipContainer,
} from 'src/components/cardGrid';
import { DynamicTooltipChip } from 'src/components/dynamicTooltipChip/DynamicTooltipChip';
import { GenericCard } from 'src/components/genericCard';
import { CustomTooltip } from 'src/components/tooltip/CustomTooltip';
import { useGetScreenSetup } from 'src/hooks/useGetScreenSetup';
import { IStatus } from 'src/interfaces';

import { AssemblyListModalCardProps } from './AssemblyListCard.interface';

export const AssemblyListCard = (props: AssemblyListModalCardProps) => {
  const { screenSetup } = useGetScreenSetup(props.card.layout_id || 0);

  return (
    <GenericCard
      isSelected={props.selectedAssemblyId === props.card.id}
      onClick={() => props.onSelectedAssembly(props.card)}
      cardMedia={
        <ChipContainer>
          {props.card.status === IStatus.READY && <LockIcon />}
          <DynamicTooltipChip
            chipName={props.card.status}
            color="success"
            variant="outlined"
            size="small"
          />
        </ChipContainer>
      }
      additionalContent={
        <>
          <CustomTooltip
            width={500}
            placement="bottom"
            title={props.card.name}
            overflowLineNumber={2}>
            <CardInfoTitle>{props.card.name}</CardInfoTitle>
          </CustomTooltip>
          {props.card.layout_id && (
            <CardContainer>
              <GridViewIcon />
              <CardText>{props.card.layout_type_name}</CardText>
            </CardContainer>
          )}
          {props.card.layout_id && (
            <CardContainer>
              <ViewWeekIcon />
              <CardText>{screenSetup}</CardText>
            </CardContainer>
          )}
        </>
      }
    />
  );
};
